<template>
  <div class="container-fluid p-0 h-100 ">
    <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">Precintado del contenedor</p>
    </div>
     <form class="w-100 form-general max-height ">
         <div class="form-group mt-2">
            <label for="nombre">Número de precinto</label>
            <input type="text" class="general-input mt-1" v-model = sealNumber placeholder="Número de precinto">
        </div>
        <div class="form-group mt-4">
            <button type="button" class="btn-general" @click="addSealNumber()" :disabled = "!sealNumber">
                ASOCIAR A EXPEDIENTE
            </button>
        </div>
     </form>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'


export default {
  name: 'sealed',
  components: {

  },
   computed: { 
   
  },
  data() {
    return {
       sealNumber: ''
    }
  },
  mounted () {
  },
  methods: { 
    addSealNumber(){
      
    }
  }
}
</script>

<style lang= "scss"  scoped>

.max-height {
    height: calc(100% - 144px);
}

.max-margin-top {
    margin-top: 100%;
}

</style>
